export default {"src":"/_next/static/media/SPXS.d0bdb1e1.svg","height":18,"width":18};